import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ children, className = '', hover = false, ...props }) => {
  const Component = hover ? motion.div : 'div';

  const hoverProps = hover ? {
    whileHover: { scale: 1.02, y: -2 },
    whileTap: { scale: 0.98 }
  } : {};

  return (
    <Component
      className={`bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-gray-200 dark:border-slate-700 transition-colors duration-200 ${className}`}
      {...hoverProps}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Card;
